import { apiClient } from '@/lib/api/apiClient';

export interface SubscriptionStatus {
  hasUsedFreeTrial: boolean;
  freeTrialUsedAt: string | null;
  gamesRemaining: number;
  totalGamesPurchased: number;
  canPlay: boolean;
  canPlayFree: boolean;
}

export interface UseTrialResponse {
  hasUsedFreeTrial: boolean;
  freeTrialUsedAt: string;
}

export interface UseGameResponse {
  gamesRemaining: number;
}

export interface AddGamesResponse {
  gamesRemaining: number;
  totalGamesPurchased: number;
}

export const subscriptionService = {
  /**
   * Get the current user's subscription status
   */
  async getStatus(): Promise<SubscriptionStatus> {
    const response = await apiClient.get<{ success: boolean; data: SubscriptionStatus }>(
      '/api/subscription/status'
    );
    return response.data.data;
  },

  /**
   * Use the free trial (marks it as used)
   */
  async useFreeTrial(): Promise<UseTrialResponse> {
    const response = await apiClient.post<{ success: boolean; data: UseTrialResponse }>(
      '/api/subscription/use-free-trial'
    );
    return response.data.data;
  },

  /**
   * Use one game from the player's purchased games
   */
  async useGame(): Promise<UseGameResponse> {
    const response = await apiClient.post<{ success: boolean; data: UseGameResponse }>(
      '/api/subscription/use-game'
    );
    return response.data.data;
  },

  /**
   * Add games to the player's account (for testing/admin)
   */
  async addGames(count: number): Promise<AddGamesResponse> {
    const response = await apiClient.post<{ success: boolean; data: AddGamesResponse }>(
      '/api/subscription/add-games',
      { count }
    );
    return response.data.data;
  },
};
